import React, { FunctionComponent } from 'react'
import styles from './Difference.module.sass'
import clsx from 'clsx'
import TriangleTop from '../../../../../files/arrow/arrow-up.svg'

interface Props {
    className?: string,
    value: [number, number],
    onClick?: () => void,
    periods?: boolean
}

const Difference: FunctionComponent<Props> = props => {
    const [cur, prev] = props.value
    return <div
        className={clsx(props.className, styles.difference, {[styles.negative]: cur < prev})}
        onClick={props.onClick}
    >
        <span className={styles.current}>{cur}</span>
        <div className={styles.diff}>
            <TriangleTop className={styles.triangle}/>
            {
                props.periods && <span>{prev === 0? 100: ((cur / prev * 100) || 0).toFixed(0)}%</span>
            }
        </div>
    </div>
}

export default Difference